import { useTranslation } from 'react-i18next';
import TextField from 'shared/components/form/TextField';
import { UpdateFormT } from 'shared/form-values/actors';
import Form from './Form';

const CreateForm = () => {
  const { t } = useTranslation();

  const fieldProps = {
    mb: '20px',
    w: {
      base: '100%',
      md: '50%',
    },
  };

  return (
    <>
      <Form />
      <TextField<UpdateFormT>
        name="apiId"
        label={t('services.table.apiId')}
        placeholder={t('services.table.apiId')}
        required
        {...fieldProps}
      />
      <TextField<UpdateFormT>
        name="apiHash"
        label={t('services.table.apiHash')}
        placeholder={t('services.table.apiHash')}
        required
        {...fieldProps}
      />
      <TextField<UpdateFormT>
        name="session"
        label={t('services.table.session')}
        placeholder={t('services.table.session')}
        required
        {...fieldProps}
      />
    </>
  );
};

export default CreateForm;
